var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_5051_50191)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "url(#paint0_radial_5051_50191)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5051_50191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 31.1197C49.95 31.6739 49.8992 32.2274 49.8492 32.7817C49.6211 35.3032 48.9148 37.6838 47.7641 39.917C46.3406 42.6796 44.4258 45.0281 41.9906 46.9184C40.2984 48.2321 38.4336 49.2125 36.4266 49.907C35.5625 50.2065 34.9969 49.7596 34.9953 48.8152C34.9922 46.9064 35.0117 44.9969 34.9828 43.0881C34.9656 41.9683 34.7461 40.891 34.0367 39.9826C33.9336 39.8505 33.8219 39.7247 33.7273 39.611C34.7195 39.3939 35.7227 39.2529 36.6773 38.9486C38.4703 38.3767 40.0734 37.4619 41.1656 35.8167C41.9008 34.7105 42.3203 33.4666 42.5383 32.1585C42.8086 30.5349 42.9055 28.9049 42.5102 27.2805C42.2281 26.1215 41.7008 25.0938 40.9352 24.1991C40.7656 24.0004 40.7453 23.8402 40.8273 23.5959C41.3914 21.9122 41.1766 20.2622 40.543 18.653C40.4867 18.5096 40.1516 18.3783 39.9727 18.4079C39.3883 18.5048 38.7805 18.5961 38.2469 18.8404C37.2305 19.3042 36.2633 19.8801 35.2656 20.3896C35.0992 20.4745 34.868 20.5297 34.6953 20.4849C32.7641 19.9778 30.7984 19.7816 28.8195 19.9314C27.6477 20.0203 26.4906 20.3071 25.3242 20.4817C25.1289 20.5105 24.8797 20.4817 24.7195 20.3767C23.4633 19.5565 22.1352 18.9061 20.6961 18.5024C20.6461 18.488 20.5953 18.4752 20.5445 18.4656C19.582 18.2934 19.4609 18.3702 19.1883 19.3298C18.7758 20.7812 18.6859 22.2294 19.1945 23.6832C19.2383 23.809 19.1867 24.0293 19.0984 24.1342C17.7023 25.7971 17.1648 27.7363 17.2438 29.903C17.293 31.2558 17.4766 32.5743 17.9 33.8599C18.6008 35.9905 19.9664 37.4779 21.9477 38.4215C23.2734 39.0535 24.6742 39.3427 26.107 39.5277C26.1555 39.5341 26.2039 39.5429 26.1953 39.5413C25.9023 40.1044 25.6031 40.6683 25.3172 41.2386C25.2477 41.378 25.182 41.5414 25.1836 41.6936C25.1891 42.2198 24.8859 42.4281 24.4438 42.5418C23.4781 42.7893 22.507 42.9872 21.5289 42.6508C20.5711 42.3215 19.8914 41.6311 19.3906 40.7572C18.7992 39.7263 17.9836 38.9718 16.8703 38.617C16.4883 38.4952 16.0484 38.4976 15.6437 38.5361C15.2805 38.5705 15.2055 38.7948 15.4227 39.0951C15.5906 39.3266 15.7875 39.5677 16.0258 39.7071C17.0172 40.2886 17.5687 41.2266 18.0516 42.227C18.218 42.5723 18.332 42.9455 18.5141 43.2811C19.1375 44.4242 20.1367 45.0049 21.3664 45.2123C22.5031 45.4038 23.6406 45.4486 24.7789 45.2163C24.8391 45.2043 24.9039 45.2147 25.0141 45.2147C25.0141 45.9901 25.0125 46.7486 25.0141 47.5064C25.0156 47.9469 25.0281 48.3875 25.0258 48.828C25.0211 49.7556 24.4375 50.2049 23.5742 49.9046C20.4789 48.828 17.7867 47.0979 15.5437 44.6468C13.9375 42.8911 12.6297 40.9326 11.6781 38.7291C10.8586 36.8307 10.3391 34.8491 10.1508 32.7801C10.1 32.2282 10.05 31.6739 10 31.1197C10 30.6655 10 30.2121 10 29.758C10.0211 29.6018 10.0453 29.4456 10.0617 29.2878C10.1516 28.4548 10.1859 27.6105 10.3367 26.7895C11.2141 21.9899 13.4602 17.973 17.107 14.8411C22.0164 10.6238 27.7 9.2141 33.95 10.4084C38.4984 11.2775 42.275 13.6444 45.2672 17.2673C47.7234 20.2414 49.2555 23.6624 49.7711 27.5392C49.8688 28.2753 49.925 29.0179 50 29.758V31.1197Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_5051_50191",
    x: -42,
    y: -42,
    width: 144,
    height: 144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 21
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5051_50191"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5051_50191",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5051_50191",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.539685 1.78512) rotate(44.0741) scale(81.4816 130.318)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101414",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5051_50191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/Github.e6110ccbc7debeb82b6e3f698962aab4.svg";
export { ForwardRef as ReactComponent };